import Vue from 'vue'
import VueRouter from 'vue-router'
// Main Routes
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Suite from '../views/Suite.vue'
import Alchemy from '../views/Alchemy.vue'
import Panoptico from '../views/Panoptico.vue'
import AutoBackups from '../views/AutoBackups.vue'
import Kairos from '../views/Kairos.vue'
import Synapse from '../views/Synapse.vue'
import Fluxity from '../views/Fluxity.vue'
import Integrations from '../views/Integrations.vue'
import Verificator from '../views/Verificator.vue'

// Axios & Cookies
import Cookies from "js-cookie";
import axios from "axios";
axios.defaults.withCredentials = true

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      protected: false
    }
  },
  {
    path: '/verificator/:temp',
    name: 'Verificator',
    component: Verificator,
    meta: {
      protected: false
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      protected: true,
      client: 'lab'
    }
  },
  {
    path: '/suite',
    name: 'Suite',
    component: Suite,
    meta: {
      protected: true
    }
  },
  {
    path: '/alchemy',
    name: 'Alchemy',
    component: Alchemy,
    meta: {
      protected: true
    }
  },
  {
    path: '/panoptico',
    name: 'Panoptico',
    component: Panoptico,
    meta: {
      protected: true
    }
  },
  {
    path: '/autobackups',
    name: 'Autobackups',
    component: AutoBackups,
    meta: {
      protected: true
   }
  },
  {
    path: '/kairos',
    name: 'Kairos',
    component: Kairos,
    meta: {
      protected: true
    }
  },
  {
    path: '/synapse',
    name: 'Synapse',
    component: Synapse,
    meta: {
      protected: true
    }
  },
  {
    path: '/fluxity',
    name: 'Fluxity',
    component: Fluxity,
    meta: {
      protected: true
    }
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: Integrations,
    meta: {
      protected: true
    }
  }
]

const bases = {
  'login': false,
  'verificator': false,
  'home': true,
  'suite': true,
  'alchemy': true,
  'panoptico': true,
  'autobackups': true,
  'kairos': true,
  'synapse': true,
  'fluxity': true,
  'integrations': true
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function clearAllIntervals() {
  for (var i = 1; i < 99999; i++)
      window.clearInterval(i);
}

function setCookie(_name, value){
  Cookies.set(_name, value);
}

function validationT1(to, from, next){
  // Validate the route existence.
  var rex = false;
  for (let i = 0; i < routes.length; i++) {
    const _route = routes[i];
    if (to.path == _route.path){ rex = true}
  }
  if (!rex){
    next('/'); 
    alert(`The section "${to.path.replace('/','')}" doesn't exists.`); 
    location.reload();
  }
  // In case of login.
  if (to.name == 'Login'){
    next()
    return
  }
  // Request parameters.
  const params = { app: to.name.toLowerCase() }
  //const dest = process.env.VUE_APP_SERVICE_URL + '/suite/main/validation'
  //console.log(process.env.NODE_ENV)
  //console.log(process.env.VUE_APP_SERVICE_URL)
  var dest = `${window.location.protocol}//${window.location.host}/kraken/suite/main/validation`
  if (process.env.NODE_ENV == 'development'){
    dest = process.env.VUE_APP_SERVICE_URL + '/suite/main/validation'
  }
  // Protected routes.
  if (to.meta.protected === true){
    axios
      .post(dest, {params})
      .then(rx => {
        // Check the validation of the app.
        var msg = rx.data.message
        if (rx.data.app == true){
          next() 
        }
        else{ 
          next('/home');
          alert(msg)
          if (from.name == 'Home'){ location.reload(); }
        }
      })
      .catch(error => {
        try {
          console.log(error.response.data.errorMessage)
        } catch (error) {
          console.log('Error', error)
        }
        next('/login')
      });
  }
  // Unprotected route
  else {
    if (to.name == "Login" && from.name != "Login"){
      axios
      .post(dest, {params})
      .then(rx => {
        next('/')
      })
      .catch(error => {
        try {
          console.log(error.response.data.errorMessage)
        } catch (error) {
          console.log('Error', error)
        }
        next()
      });
    }
  }
}

function validationT2(to, from, next){
  var base = to.path.split('/')[1]
  var from_base = from.path.split('/')[1]
  if (base == 'login' && from_base != 'login'){
    //
    next()
  }
  else if (base == "verificator"){
    //next()
    //return
    // VALIDATE USER and CODE.
    var vlus = prompt('Username:')
    if (!vlus){
      return 
    }
    var vlcd = prompt('Verification code:')
    if (!vlus){
      return 
    }
    // VALIDATE URL (ALIVE), user and code.
    var dest = `${window.location.protocol}//${window.location.host}/kraken/suite/main/verificator`
    if (process.env.NODE_ENV == 'development'){
      dest = process.env.VUE_APP_SERVICE_URL + '/suite/main/verificator'
    }
    axios.post(dest, {username:vlus, verification_code:vlcd, token_url: to.params.temp})
      .then(rx => {
        if (rx.data.valid){ next() }
        else{ alert('Expired/Invalid session');} // next
      })
      .catch(error => {
        console.log(error)
      });
  }
}


// Every time you enter in a view, this will be executed.
router.beforeEach((to, from, next) => {
  // Clear all intervals between routes.
  if (process.env.NODE_ENV != 'development'){
    clearAllIntervals(); // Activate in prod.
  }
  // Validations
  var base = to.path.split('/')[1]
  var prot = to.meta.protected
  // Inexistent route.
  if (!Object.keys(bases).includes(base)){
    next('/login')
  }
  // PV validation
  else if (prot){
    validationT1(to, from, next)
  }
  // PB validation
  else if (!prot){
    validationT2(to, from, next)
  }
})

export default router
